<div class="modal-content">
  <div
    class="modal__content"
    [class.modal__blueBackground]="isDefault"
    [class.modal__redBackground]="isDanger"
  >
    <div class="modal__header">
      <img class="modal__img-centered" [src]="icon" />
    </div>
    <div class="modal__body">
      <h4
        class="h4 modal__body_title"
        [class.modal__blueBackground]="isDefault"
        [class.modal__redBackground]="isDanger"
      >
        {{ title }}
      </h4>
      <span
        [class.modal__blueBackground]="isDefault"
        [class.modal__redBackground]="isDanger"
      >
        {{ body }}
      </span>
      <button
        (click)="onClickClose()"
        type="button"
        id=""
        class="btn-primary btn-large is-block"
        [class.modal__blueButton]="isDefault"
        [class.modal__redButton]="isDanger"
      >
        {{ 'sharedModule.bkgRecoveryPassDialog.accept' | translate }}
      </button>
    </div>
  </div>
</div>
